import { CURRENCY_SYMBOL, DOC_UPLOAD_VALIDATION, REGEX_CAMEL_CASE } from './constant';
import forge from 'node-forge';
import { Buffer } from 'buffer';
import { toast } from 'react-toastify';
import JSZip from "jszip";
import { saveAs } from "file-saver";

const ENCRYPTION_AES_ENC_KEY_OPTIONS = {
    iterations: 100,
    keySize: 16
}

export const isUserHasAccessPage = (params: { permissionID: string | number, accessType: any, assignUserId?: string | null | undefined }) => {
    // let { permissionID, accessType, assignUserId } = params;

    return true
}

//function to convert file into base 64 for previewing image
export const toBase64 = (file: any) => {
    return new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.readAsDataURL(file)
        reader.onload = () => resolve(reader.result)
        reader.onerror = error => reject(error)
    })
}

/**
 * function to detect media type of base 64 buffer/array
 * @param {Array} b64 
 * @returns {String} match media type
 */
export const detectMimeType = (b64: any, others?: { allowedExtensions: Array<any> }) => {
    return new Promise((resolve, reject) => {
        if (!b64) resolve(false)

        let fileType = b64.split(';')[0]
        b64 = b64.split(',')[1]

        const signatures: any = {
            iVBORw0KGgo: "image/png",
            "/9j/": "image/jpg",
            ffd8ffe0: "image/jpeg",
            ffd8ffe1: "image/jpeg",
            ffd8ffe2: "image/jpeg",
            ffd8ffe3: "image/jpeg",
            ffd8ffe8: "image/jpeg"
        }

        for (const s in signatures) {
            if (b64.indexOf(s) === 0) {
                return resolve(signatures[s])
            }
        }

        //if not image
        if (others && others.allowedExtensions) {
            if (others.allowedExtensions.includes(fileType)) {
                return resolve(true)
            }
        }

        return resolve(false)
    })
}


export const addCurrencyFormatting = (number: any) => {
    number = number ? number.toString().replace(/,/g, '') : 0;
    return CURRENCY_SYMBOL + ' ' + (+number ? (+number).toLocaleString("en-EU") : 0);
}

export const removeCurrencyFormatting = (number: any) => {
    if (number) {
        var result = ('' + number).replace(/[Rp]+/g, "").replace(/[₱]+/g, "").replace(/[AED]+/g, "").replace(/,/g, "");
        return result.toString().trim()
    }
}

export const isUserHasUpdateAccess = (params: any) => {
    return true

}

export const nthNumber = (number: number) => {
    if (number > 3 && number < 21) return ("th");
    switch (number % 10) {
        case 1:
            return ("st");
        case 2:
            return ("nd");
        case 3:
            return ("rd");
        default:
            return ("th");
    }
};

//GENERATE AES KEY HANDLER
export const generateAesKey = () => {
    const aesSalt = forge.random.getBytesSync(ENCRYPTION_AES_ENC_KEY_OPTIONS.keySize);
    const keyPassPhrase = forge.random.getBytesSync(ENCRYPTION_AES_ENC_KEY_OPTIONS.keySize);
    const aesKey = forge.pkcs5.pbkdf2(
        keyPassPhrase,
        aesSalt,
        ENCRYPTION_AES_ENC_KEY_OPTIONS.iterations, // use according to your requirement
        ENCRYPTION_AES_ENC_KEY_OPTIONS.keySize, // use according to your requirement
    );
    return aesKey;
};

//ENCRYPTION HANDLER
export const encryptAesKey = (params: any) => {
    try {
        let { encPubKey, body, URL } = params;
        let symmetricKey = forge.random.getBytesSync(16);
        let iv = forge.random.getBytesSync(16);
        var encryptedReqData: any;
        let encryptedSymmetricKey: any;
        let isBodyLength = false;
        let formObj: any = {};
        let updatedFormData = new FormData();

        if (URL.indexOf('/addDocumentWeb') >= 0 || URL.indexOf('/uploadCsv') >= 0 || URL.indexOf('/uploadAddOnCsv') >= 0 || URL.indexOf('/addInsurancePartner') >= 0 || URL.indexOf('/updateInsurancePartner') >= 0 || URL.indexOf('/addAgencyWebDocument') >= 0 || URL.indexOf('/paymentProofDocs') >= 0 || URL.indexOf('/uploadAndReadDocument') >= 0 || URL.indexOf('/uploadLeadDocImages') >= 0 || URL.indexOf('travel/lead/docs_upload') >= 0) {
            for (var pair of body.entries()) {
                if (pair[0] !== "files") {
                    formObj[pair[0]] = pair[1]
                } else {
                    updatedFormData.append('files', pair[1])
                }
            }

            // updatedFormData.set('formData', formObj)//storage.encrypt(JSON.stringify(formObj), generateAesKey))

            // body = formObj//{...body, ...updatedFormData};
            isBodyLength = true;
        } else {
            isBodyLength = (body && Object.keys(body)?.length);
            // body = JSON.stringify(body)
        }

        if (isBodyLength) {

            let cipher = forge.cipher.createCipher('AES-CBC', symmetricKey);
            cipher.start({ iv: iv });
            cipher.update(forge.util.createBuffer(JSON.stringify(body), 'utf8'));
            cipher.finish();
            // encryptedReqData = cipher.output.toHex();
            encryptedReqData = forge.util.encode64(cipher.output.getBytes());

            if (Object.keys(formObj).length) {
                updatedFormData.append('formData', encryptedReqData)
                encryptedReqData = body//updatedFormData

            }


            const publicKey = forge.pki.publicKeyFromPem(encPubKey);
            encryptedSymmetricKey = publicKey.encrypt(symmetricKey, 'RSA-OAEP');
            encryptedSymmetricKey = forge.util.encode64(encryptedSymmetricKey);

        }

        return { encryptedReqData, iv: forge.util.encode64(iv), symmetricKey: encryptedSymmetricKey };
    } catch (error) {
        throw error;
    }
};


// Decrypt encrypted data using AES decryption
const DecryptData = (encryptedData: any, iv: string, symmetricKey: string) => {
    try {
        const decipher = forge.cipher.createDecipher('AES-CBC', forge.util.decode64(symmetricKey));
        decipher.start({ iv: forge.util.decode64(iv) });
        decipher.update(forge.util.createBuffer(forge.util.decode64(encryptedData), 'raw'));
        decipher.finish();
        return JSON.parse(decipher.output.toString());
    } catch (err) {
        throw new Error('Unable to decrypt data');
    }
}

export const DecryptResponse = (response: any) => {
    let decryptRespose = response;
    if (response && response.data && response.data.data) {

        let decryptDataResp = DecryptData(response.data.data, response.headers.responseiv, response.headers.responseaeskey);
        if (decryptDataResp?.data) { //IF MULTIPLE KEYS EXISTS

            decryptRespose = { ...response.data, ...decryptDataResp };
        } else { //IF SINGLE ARRAY
            decryptRespose = { ...response.data, data: decryptDataResp };

        }

    }
    return decryptRespose;
}

export async function convertImgsToFiles(files: Array<{ url: string, fileName: string, doc_id: any }>) {
    try {
        const filePromises = files.map(async ({ url, fileName, doc_id }) => {
            const response = await fetch(url);

            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            const blob = await response.blob();
            return {
                file: new File([blob], fileName, {
                    type: blob.type,
                    lastModified: Date.now()
                }),
                doc_id
            }
        });

        return await Promise.all(filePromises);
    } catch (error) {
        console.error('Error fetching the files:', error);
        throw error;
    }
}

export const EncodetoBase64 = (data: any) => {
    try {
        if (data) {
            const stringData = JSON.stringify(data)

            return Buffer.from(stringData, 'utf-8').toString('base64')
        }
        else return ''
    } catch (error) {
        return ''
    }
}

export const ValidateFileInput = (files: any) => {
    return new Promise(async (resolve, reject) => {
        try {
            let errorFlag = false
            let allowedExtensions = ['data:application/vnd.openxmlformats-officedocument.wordprocessingml.document', 'data:application/pdf', 'data:application/msword', 'data:text/csv']
            let allowedExtensionsXls = ['data:application/vnd.ms-excel', 'data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', 'data:application/excel', 'data:application/x-excel', 'data:application/x-msexcel'];

            for (let file of files) {
                const base64PreviewImg = await toBase64(file)
                const filetype: any = await detectMimeType(base64PreviewImg, { allowedExtensions: [...allowedExtensions, ...allowedExtensionsXls] })
                const fileSize = file.size

                if (!filetype) {
                    toast.error("File format should be jpg, jpeg, png, pdf, doc, docx, csv, xls, xlsx")
                    errorFlag = true
                    break
                } else if (fileSize < DOC_UPLOAD_VALIDATION['minSize'] || fileSize > DOC_UPLOAD_VALIDATION['maxSize']) {
                    if (fileSize < DOC_UPLOAD_VALIDATION['minSize'] && allowedExtensionsXls.includes('data:' + file.type)) {
                        //     // continue;
                    } else {
                        if (allowedExtensionsXls.includes('data:' + file.type)) {
                            toast.error("Xls file size should be upto 5mb")
                        } else {
                            toast.error("File size should be between 25kb to 5mb")
                        }
                        errorFlag = true
                        break
                    }
                }
            }

            return resolve(errorFlag)
        } catch (error) {
            return resolve(true)
        }
    })
}

export const isAllSubRangesDefined = (ranges: any, start: any, end: any) => {
    // Sort ranges by their start values to make it easier to check for overlaps
    ranges.sort((a: any, b: any) => a[0] - b[0]);

    // Initialize a variable to track the end of the last processed range
    let lastEnd = start - 1;

    // Helper to handle precision issues
    const isClose = (a: any, b: any, epsilon = 1e-8) => Math.abs(a - b) < epsilon;

    // Iterate through each range to check validity
    for (const [subStart, subEnd] of ranges) {
        if (subStart < start || subEnd > end || subStart > subEnd) {
            // Invalid subrange: Out of bounds or reversed range
            return false;
        }

        // Check for gaps (allowing for perfect alignment or floating-point precision)
        if (!isClose(subStart, lastEnd + 1) && subStart > lastEnd + 1) {
            // Gap detected
            return false;
        }

        // Update the last processed range end
        lastEnd = Math.max(lastEnd, subEnd);
    }

    // Check if all numbers up to 'end' are covered
    return isClose(lastEnd, end);
}

export const validateBiPdAdjustment = (ranges: any[]) => {
    // Iterate through each range to validate
    for (const range of ranges) {
        const {
            bi_pd_adjustment,
            referral_fee_scheme,
            net_rate_value,
            referral_fee_percentage,
        } = range;
        // Validate Net Value 

        if (referral_fee_scheme !== 1) {
            if (net_rate_value < 0 || net_rate_value > 10) {
                return {
                    isValid: false,
                    errorRange: { min: 0, max: 10, net_rate_value: net_rate_value, bi_pd_adjustment: bi_pd_adjustment },
                    errorType: 1
                };
            }
        } else {
            if (referral_fee_percentage < 0 || referral_fee_percentage > 10) {
                return {
                    isValid: false,
                    errorRange: { min: 0, max: 10, net_rate_value: net_rate_value, bi_pd_adjustment: bi_pd_adjustment, referral_fee_percentage: referral_fee_percentage },
                    errorType: 3
                };
            }
        }
        // Only validate for referral_fee_scheme === 3 or 4
        if (referral_fee_scheme === 3 || referral_fee_scheme === 4) {
            if (bi_pd_adjustment < 0 || bi_pd_adjustment > 50) {
                // Return the invalid range details
                return {
                    isValid: false,
                    errorRange: { min: 0, max: 50, net_rate_value: net_rate_value, bi_pd_adjustment: bi_pd_adjustment },
                    errorType: 2
                };
            }
        }
    }

    // All ranges are valid
    return {
        isValid: true,
        errorRange: null,
        errorType: 0
    };
};

export const dateReturn = (ch: any) => {
    try {
        const currentDate = new Date();
        let from_date = null;
        let to_date = null;
        switch (ch) {
            case 'all':
                to_date = currentDate.toISOString().split('T')[0];
                break;
                
            case 'mtd':
                const firstDayOfMonth = new Date(currentDate.getFullYear(),currentDate.getMonth(),1);
                from_date = `${firstDayOfMonth.getFullYear()}-${String(firstDayOfMonth.getMonth() + 1).padStart(2, '0')}-${String(firstDayOfMonth.getDate()).padStart(2, '0')}`;
                to_date = `${currentDate.getFullYear()}-${String(currentDate.getMonth() + 1).padStart(2, '0')}-${String(currentDate.getDate()).padStart(2, '0')}`;
                break;

            case 'nd':
                let currentNewDate = new Date(currentDate); 
                currentNewDate.setDate(currentDate.getDate() + 1);
                from_date = currentNewDate.toISOString().split('T')[0];
                const next7Days = new Date(currentDate);
                next7Days.setDate(currentDate.getDate() + 7);
                to_date = next7Days.toISOString().split('T')[0];
                break;
        
            case 'nm':
                const firstDayNextMonth = new Date(Date.UTC(currentDate.getFullYear(), currentDate.getMonth() + 1, 1, 0, 0, 0));
                const lastDayNextMonth = new Date(Date.UTC(currentDate.getFullYear(), currentDate.getMonth() + 2, 0, 23, 59, 59, 999));
                from_date = firstDayNextMonth.toISOString().split('T')[0];
                to_date = lastDayNextMonth.toISOString().split('T')[0];
                break;
        
            case 'mdd':
                const yesterday = new Date(currentDate);
                yesterday.setDate(currentDate.getDate() - 1);
                to_date = yesterday.toISOString().split('T')[0];
                break;
            default:
            return null;
        }
        return { from_date, to_date };
    }catch(error){

    }
}


export const downloadPolicy = async (urls: any[], fileName = "Policies.zip", type: 'single' | 'multiple' = 'single') => {
    if (urls.length) {
        const zip = new JSZip();
        const fetchPromises: Promise<void>[] = [];

        if (type === 'single') {
            // For a single policy download (assuming `urls` is an array with a single item)
            const data = urls[0];
            const url = data.doc_path?.split('?')?.[0];
            const fileName = url?.split('/').pop();

            // Fetch file and add it to the ZIP
            fetchPromises.push(
                fetch(data.doc_path)
                    .then(response => response.blob())
                    .then(blob => {
                        zip.file(fileName, blob); // Add file directly to the root of the ZIP
                    })
            );
        } else if (type === 'multiple') {
            // For multiple policies download
            urls.forEach((entry) => {
                const formattedCustomerName = entry.name
                    .toLowerCase()
                    .replace(REGEX_CAMEL_CASE, (word: string, index: number) =>
                        index === 0 ? word.toLowerCase() : word.toUpperCase()
                    )
                    .replace(/\s+/g, "");
                const folderName = `${formattedCustomerName}_${entry.policy_number}`;
                const folder = zip.folder(folderName);

                if (folder) {
                    entry.doc_path.forEach((docUrl:any) => {
                        const url = docUrl.split('?')[0];
                        const fileName = url.split('/').pop() ?? "unknown";

                        // Fetch file and add to folder
                        fetchPromises.push(
                            fetch(docUrl)
                                .then((response) => response.blob())
                                .then((blob) => {
                                    folder.file(fileName, blob); // Add file to the folder
                                })
                        );
                    });
                }
            });
        }

        try {
            // Wait for all files to be fetched and added to the ZIP
            await Promise.all(fetchPromises);

            // Generate the ZIP file
            const content = await zip.generateAsync({ type: "blob" });

            // Trigger the download
            saveAs(content, fileName);
        } catch (error) {
            console.error("Error creating ZIP file:", error);
            toast.error("Failed to download files.");
        }
    } else {
        toast.error("No File Found");
    }
};




